import React from 'react';
import UnderConstruction from '../components/UnderConstruction';

const Profile: React.FC = () => {
  return <UnderConstruction title="个人中心" />;
};

export default Profile; 